<template>
  <div class="archive-payments">
    <div class="archive-payments__groups">
      <base-loader v-if="pageLoading" />
      <div
        class="archive__group"
        v-for="order in orders"
        :key="`order-${order.id}`"
      >
        <div class="archive__client-info">
          <div class="archive__client-info-title">
            {{ $t("archive.client_info.title") }}
          </div>
          <div class="archive__client-info-item">
            <div class="archive__client-info-item-title">
              {{ $t("archive.client_info.full_name") }}
            </div>
            <div class="archive__client-info-item-value">
              {{ order.client.full_name }}
            </div>
          </div>
          <div class="archive__client-info-item">
            <div class="archive__client-info-item-title">
              {{ $t("cart.client_info.inn") }}
            </div>
            <div class="archive__client-info-item-value">
              {{ order.client.inn }}
            </div>
          </div>
          <div
            class="archive__update-status"
            @click="updateOrderStatus(order.id)"
          >
            {{ $t("archive.status.update") }}
          </div>
        </div>
        <table class="archive__table">
          <span class="archive__table-border"></span>
          <thead>
            <tr>
              <td>{{ $t("archive.table.created") }}</td>
              <td>{{ $t("archive.table.payer") }}</td>
              <td>{{ $t("archive.table.payment_type") }}</td>
              <td>{{ $t("archive.table.amount") }}</td>
              <td>{{ $t("archive.table.status") }}</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr
              class="archive__item"
              v-for="orderItem in order.items"
              :key="`order-item-${orderItem.id}`"
            >
              <td>
                <div class="archive__item-created">
                  <div class="archive__item-created-date">
                    {{ $moment(orderItem.created_at).format("DD.MM.YY") }}
                  </div>
                  <div class="archive__item-created-time">
                    {{ $moment(orderItem.created_at).format("hh:mm:ss") }}
                  </div>
                </div>
              </td>
              <td>
                <div class="archive__item-recipient">
                  {{ order.client.full_name }}
                </div>
              </td>
              <td>
                <div class="archive__item-payment_type">
                  {{ $t(orderItem.payment_type.slug) }}
                </div>
              </td>
              <td>
                <div class="archive__item-amount">{{ orderItem.sum_full }}</div>
              </td>
              <td style="z-index: 4">
                <div class="archive__item-amount">
                  <div class="archive__item-amount-text">
                    {{ $t(itemStatus(orderItem, order)) }}
                  </div>
                  <div
                    class="archive__item-receipt"
                    v-if="orderItem.status === orderStatuses.paid"
                  >
                    <div
                      class="archive__item-receipt-print-options"
                      v-if="orderItemReceiptsActive === orderItem.id"
                      v-click-outside="hideReceiptOptions"
                    >
                      <div
                        class="archive__item-receipt-print-option"
                        :class="{
                          disabled: isReceiptLoading(orderItem.id, 'payment'),
                        }"
                        @click="downloadReceipt(orderItem.id, 'payment')"
                      >
                        {{
                          isReceiptLoading(orderItem.id, "payment")
                            ? $t("loading")
                            : $t("archive.cart_item.receipt.payment")
                        }}
                      </div>
                      <div
                        class="archive__item-receipt-print-option"
                        :class="{
                          disabled: isReceiptLoading(
                            orderItem.id,
                            'commission'
                          ),
                        }"
                        @click="downloadReceipt(orderItem.id, 'commission')"
                      >
                        {{
                          isReceiptLoading(orderItem.id, "commission")
                            ? $t("loading")
                            : $t("archive.cart_item.receipt.commission")
                        }}
                      </div>
                    </div>
                    <div
                      class="archive__item-receipt-print"
                      @click="showReceiptOptions(orderItem.id)"
                    >
                      <svg
                        width="19"
                        height="19"
                        viewBox="0 0 19 19"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.2168 4.78711H15.6973V2.7832C15.6973 1.24854 14.4487 0 12.9141 0H6.08594C4.55128 0 3.30273 1.24854 3.30273 2.7832V4.78711H2.7832C1.24854 4.78711 0 6.03565 0 7.57031V12.0234C0 13.5581 1.24854 14.8066 2.7832 14.8066H3.30273V17.3301C3.30273 18.2509 4.05186 19 4.97266 19H14.0273C14.9481 19 15.6973 18.2509 15.6973 17.3301V14.8066H16.2168C17.7515 14.8066 19 13.5581 19 12.0234V7.57031C19 6.03565 17.7515 4.78711 16.2168 4.78711ZM4.41602 2.7832C4.41602 1.86241 5.16514 1.11328 6.08594 1.11328H12.9141C13.8349 1.11328 14.584 1.86241 14.584 2.7832V4.78711H4.41602V2.7832ZM14.584 17.3301C14.584 17.637 14.3343 17.8867 14.0273 17.8867H4.97266C4.66572 17.8867 4.41602 17.637 4.41602 17.3301V11.8379H14.584V17.3301ZM17.8867 12.0234C17.8867 12.9442 17.1376 13.6934 16.2168 13.6934H15.6973V11.8379H16.0312C16.3387 11.8379 16.5879 11.5887 16.5879 11.2812C16.5879 10.9738 16.3387 10.7246 16.0312 10.7246H2.96875C2.66134 10.7246 2.41211 10.9738 2.41211 11.2812C2.41211 11.5887 2.66134 11.8379 2.96875 11.8379H3.30273V13.6934H2.7832C1.86241 13.6934 1.11328 12.9442 1.11328 12.0234V7.57031C1.11328 6.64952 1.86241 5.90039 2.7832 5.90039H16.2168C17.1376 5.90039 17.8867 6.64952 17.8867 7.57031V12.0234Z"
                          fill="#5C91F2"
                        />
                        <path
                          d="M10.9844 13.0996H8.01562C7.70821 13.0996 7.45898 13.3488 7.45898 13.6562C7.45898 13.9637 7.70821 14.2129 8.01562 14.2129H10.9844C11.2918 14.2129 11.541 13.9637 11.541 13.6562C11.541 13.3488 11.2918 13.0996 10.9844 13.0996Z"
                          fill="#5C91F2"
                        />
                        <path
                          d="M10.9844 15.4746H8.01562C7.70821 15.4746 7.45898 15.7238 7.45898 16.0312C7.45898 16.3387 7.70821 16.5879 8.01562 16.5879H10.9844C11.2918 16.5879 11.541 16.3387 11.541 16.0312C11.541 15.7238 11.2918 15.4746 10.9844 15.4746Z"
                          fill="#5C91F2"
                        />
                        <path
                          d="M4.75 7.16211H2.96875C2.66134 7.16211 2.41211 7.41134 2.41211 7.71875C2.41211 8.02616 2.66134 8.27539 2.96875 8.27539H4.75C5.05741 8.27539 5.30664 8.02616 5.30664 7.71875C5.30664 7.41134 5.05741 7.16211 4.75 7.16211Z"
                          fill="#5C91F2"
                        />
                      </svg>
                    </div>
                  </div>

                  <div
                    class="archive__item-pay-link"
                    v-else-if="itemStatus(orderItem, order) === orderStatuses.pending"
                    @click="toPayUrl(order.widget_url)"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      width="442.246px"
                      height="442.246px"
                      viewBox="0 0 442.246 442.246"
                      xml:space="preserve"
                    >
                      <path
                        d="M409.657,32.474c-43.146-43.146-113.832-43.146-156.978,0l-84.763,84.762c29.07-8.262,60.589-6.12,88.129,6.732    l44.063-44.064c17.136-17.136,44.982-17.136,62.118,0c17.136,17.136,17.136,44.982,0,62.118l-55.386,55.386l-36.414,36.414    c-17.136,17.136-44.982,17.136-62.119,0l-47.43,47.43c11.016,11.017,23.868,19.278,37.332,24.48    c36.415,14.382,78.643,8.874,110.467-16.219c3.06-2.447,6.426-5.201,9.18-8.262l57.222-57.222l34.578-34.578    C453.109,146.306,453.109,75.926,409.657,32.474z"
                        fill="#5C91F2"
                      />
                      <path
                        d="M184.135,320.114l-42.228,42.228c-17.136,17.137-44.982,17.137-62.118,0c-17.136-17.136-17.136-44.981,0-62.118    l91.8-91.799c17.136-17.136,44.982-17.136,62.119,0l47.43-47.43c-11.016-11.016-23.868-19.278-37.332-24.48    c-38.25-15.3-83.232-8.262-115.362,20.502c-1.53,1.224-3.06,2.754-4.284,3.978l-91.8,91.799    c-43.146,43.146-43.146,113.832,0,156.979c43.146,43.146,113.832,43.146,156.978,0l82.927-83.845    C230.035,335.719,220.243,334.496,184.135,320.114z"
                        fill="#5C91F2"
                      />
                    </svg>
                  </div>
                </div>
              </td>
              <td>
                <div class="archive__item-actions">
                  <div
										v-if="orderItem.status !== orderStatuses.in_progress"
                    @click="repeatPayment(orderItem.id)"
                    class="archive__item-action archive__item-action--repeat"
                  >
                    <div class="archive__item-action-icon">
                      <svg
                        width="14"
                        height="16"
                        viewBox="0 0 14 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M13 9C13 12.3137 10.3137 15 7 15C3.68629 15 1 12.3137 1 9C1 5.68629 3.68629 3 7 3"
                          stroke="#5C91F2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                        <path
                          d="M6.5 5.5L7.68615 3.04253C7.95137 2.49304 7.66694 1.83618 7.08473 1.65365L5.00012 1.00006"
                          stroke="#5C91F2"
                          stroke-width="1.5"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>
                    <div class="archive__item-action-text">
                      {{ $t("archive.table.action.repeat") }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="archive__total">
          <div class="archive__total-title">
            {{ $t("archive.total.section_title") }}
          </div>
          <div class="archive__total-amount">
            <div class="archive__total-amount-title">
              {{
                $t("archive.total.title", { itemsCount: order.items.length })
              }}
            </div>
            <div class="archive__total-amount-value">
              {{ roundOrderSum(getOrderDisplaySum(order)) }} {{ $t("currency") }}
            </div>
          </div>
          <div
            class="archive__receipt"
            v-if="order.status === orderStatuses.paid"
          >
            <div
              class="archive__receipt-print-options"
              v-if="orderItemReceiptsActive === `order-${order.id}`"
              v-click-outside="hideReceiptOptions"
            >
              <div
                class="archive__receipt-print-option"
                :class="{
                  disabled: isReceiptLoading(`order-${order.id}`, 'payment'),
                }"
                @click="downloadOrderReceipt(order.id, 'payment')"
              >
                {{
                  isReceiptLoading(`order-${order.id}`, "payment")
                    ? $t("loading")
                    : $t("archive.cart_item.receipt.payment")
                }}
              </div>
              <div
                class="archive__receipt-print-option"
                :class="{
                  disabled: isReceiptLoading(`order-${order.id}`, 'commission'),
                }"
                @click="downloadOrderReceipt(order.id, 'commission')"
              >
                {{
                  isReceiptLoading(`order-${order.id}`, "commission")
                    ? $t("loading")
                    : $t("archive.cart_item.receipt.commission")
                }}
              </div>
            </div>
            <div
              class="archive__receipt-print"
              @click="showReceiptOptions(`order-${order.id}`)"
            >
              <div class="archive__receipt-print-text">
                {{ $t("archive.cart_item.receipt.download") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="archive-payments__pagination"
      v-if="paginationVisible"
    >
      <div class="archive-payments__pagination-controls">
        <button
          type="button"
          class="archive-payments__pagination-button"
          :disabled="page === 1 || pageLoading"
          @mousedown.prevent
          @click="setPage(page - 1)"
        >
          ‹
        </button>
        <button
          v-for="pageNumber in pages"
          :key="pageNumber"
          type="button"
          class="archive-payments__pagination-button"
          :class="{ 'archive-payments__pagination-button--active': pageNumber === page }"
          :disabled="pageLoading"
          @mousedown.prevent
          @click="setPage(pageNumber)"
        >
          {{ pageNumber }}
        </button>
        <button
          type="button"
          class="archive-payments__pagination-button"
          :disabled="page === totalPages || pageLoading"
          @mousedown.prevent
          @click="setPage(page + 1)"
        >
          ›
        </button>
      </div>
    </div>
    <div class="archive-payments__actions">
      <primary-button
        :text="$t('archive.action.create_payment')"
        @click="toCreatePayment"
      ></primary-button>
    </div>
  </div>
</template>

<script>
import { OrderApi } from "@/office/order/order-api";
import FileSaver from "file-saver";
import PrimaryButton from "@/components/buttons/PrimaryButton";
import BaseLoader from "@/components/base/BaseLoader";
import { STATUS_PAID, STATUS_PENDING, STATUS_IN_PROGRESS } from "@/const/order/order-statuses";

export default {
  name: "ArchivePayments",
  components: { PrimaryButton, BaseLoader },
  data() {
    return {
      orders: [],
      page: 1,
      perPage: 50,
      pagination: null,
      pageLoading: false,
      orderStatuses: {
        paid: STATUS_PAID,
        pending: STATUS_PENDING,
        in_progress: STATUS_IN_PROGRESS,
      },
      orderItemReceiptsActive: null,
      orderItemReceiptsLoading: [],
      ordersLoaded: false,
    };
  },
  created() {
    this.loadOrders();
  },
  computed: {
    totalItems() {
      if (this.pagination && this.pagination.total != null) {
        return Number(this.pagination.total);
      }

      return this.orders.length;
    },
    totalPages() {
      if (this.pagination && this.pagination.last_page != null) {
        return Number(this.pagination.last_page);
      }

      return Math.max(1, Math.ceil(this.totalItems / this.perPage));
    },
    pages() {
      return Array.from({ length: this.totalPages }, (_, index) => index + 1);
    },
    paginationVisible() {
      return this.ordersLoaded && this.totalPages > 1;
    },
    pageStart() {
      if (this.pagination && this.pagination.from != null) {
        return Number(this.pagination.from);
      }
      return this.totalItems === 0 ? 0 : (this.page - 1) * this.perPage + 1;
    },
    pageEnd() {
      if (this.pagination && this.pagination.to != null) {
        return Number(this.pagination.to);
      }
      return Math.min(this.totalItems, this.page * this.perPage);
    },
  },
  methods: {
		itemStatus(item, order) {
			return (item && item.status != null) ? item.status : order.status
		},
    loadOrders(pageNumber = 1) {
      const initialLoad = this.orders.length === 0;
      if (initialLoad) {
        this.ordersLoaded = false;
      } else {
        this.pageLoading = true;
      }

      new OrderApi()
        .getOrders({
          page: pageNumber,
          per_page: this.perPage,
        })
        .then((r) => {
          const responseData = r.data || {};
          this.orders = responseData.orders || [];
          this.pagination = responseData.pagination || null;
          this.page =
            (this.pagination && this.pagination.current_page) || pageNumber;
        })
        .finally(() => {
          this.ordersLoaded = true;
          this.pageLoading = false;
        });
    },
    setPage(pageNumber) {
      if (pageNumber === this.page) {
        return;
      }

      const page = Math.min(Math.max(pageNumber, 1), this.totalPages);
      this.loadOrders(page);
    },
    downloadReceipt(orderItemId, receiptType) {
      if (this.isReceiptLoading(orderItemId, receiptType)) {
        return;
      }

      this.orderItemReceiptsActive = null;

      this.orderItemReceiptsLoading.push({ id: orderItemId, receiptType });
      new OrderApi()
        .loadReceipt(orderItemId, receiptType)
        .then((r) => {
          FileSaver.saveAs(r.data, `Receipt-payment-${orderItemId}.pdf`);
        })
        .finally(() => {
          let _index = this.orderItemReceiptsLoading.findIndex(
            (_item) =>
              _item.id === orderItemId && _item.receiptType === receiptType
          );

          this.orderItemReceiptsLoading.splice(_index, 1);
        });
    },
    downloadOrderReceipt(orderId, receiptType) {
      if (this.isReceiptLoading(`order-${orderId}`, receiptType)) {
        return;
      }

      this.orderItemReceiptsActive = null;

      this.orderItemReceiptsLoading.push({
        id: `order-${orderId}`,
        receiptType,
      });
      new OrderApi()
        .loadOrderPDFReceipt(orderId, receiptType)
        .then((r) => {
          FileSaver.saveAs(r.data, `Receipt-${orderId}-${receiptType}.pdf`);
        })
        .finally(() => {
          let _index = this.orderItemReceiptsLoading.findIndex(
            (_item) =>
              _item.id === `order-${orderId}` &&
              _item.receiptType === receiptType
          );

          this.orderItemReceiptsLoading.splice(_index, 1);
        });
    },
    isReceiptLoading(orderItemId, receiptType) {
      return (
        this.orderItemReceiptsLoading.findIndex(
          (_item) =>
            _item.id === orderItemId && _item.receiptType === receiptType
        ) > -1
      );
    },
		updateOrderStatus(orderId) {
			new OrderApi().getOrderStatus(orderId).then((r) => {
				const orderIndex = this.orders.findIndex(o => o.id === orderId)
				if (orderIndex === -1) return

				const itemsFromApi = Array.isArray(r.data.items) ? r.data.items : []
				const mapStatus = new Map(itemsFromApi.map(i => [i.id, i.status]))

				const prev = this.orders[orderIndex]
				this.orders[orderIndex] = {
					...prev,
					status: r.data.status,
					items: prev.items.map(it => ({
						...it,
						status: mapStatus.has(it.id) ? mapStatus.get(it.id) : it.status
					})),
				}

				this.orders = [...this.orders]
				console.log('updateOrderStatus orders', this.orders)
			})
		},
    toCreatePayment() {
      this.$router.push("/");
    },
    toPayUrl(widgetUrl) {
      window.open(widgetUrl, "_blank");
    },
    showReceiptOptions(orderItemId) {
      this.orderItemReceiptsActive = orderItemId;
    },
    hideReceiptOptions() {
      this.orderItemReceiptsActive = null;
    },
    repeatPayment(orderItemId) {
      this.$router.push({
        path: "/",
        query: {
          repeat_item_id: orderItemId,
        },
      });
    },
    getOrderDisplaySum(order) {
      return order.displaySum !== undefined ? order.displaySum : order.sum;
    },
    roundOrderSum(sum) {
      return Math.round((sum + Number.EPSILON) * 100) / 100;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_variables.scss";
@import "~@/assets/scss/_mixins.scss";

.archive {
  &__group {
    margin-bottom: 30px;
  }

  &__update {
    &-status {
      font-weight: bold;
      color: $action;
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      margin-left: auto;
      cursor: pointer;
      transition: opacity 0.2s linear;

      &:hover {
        opacity: 0.8;
      }
    }
  }

  &__client-info {
    padding: 23px 32px;
    display: flex;
    align-items: center;
    border: 1px solid #f0f3fa;
    border-bottom: unset;
    border-radius: 16px 16px 0 0;

    &-title {
      color: $textLight;
      font-size: pxToRem(10);
      line-height: pxToRem(12);
      margin-right: 25px;
    }

    &-item {
      display: flex;
      align-items: center;
      margin-right: 40px;

      &:last-child {
        margin-right: 0;
      }

      &-title {
        font-weight: 600;
        font-size: pxToRem(12);
        line-height: pxToRem(15);
        color: $text;
        margin-right: 5px;
      }

      &-value {
        font-weight: 600;
        font-size: pxToRem(12);
        line-height: pxToRem(15);
        color: $action;
      }
    }
  }

  &__table {
    width: 100%;
    position: relative;
    border-collapse: collapse;

    &-border {
      position: absolute;
      width: 100%;
      height: 100%;
      border: 1px solid #f0f3fa;
      border-radius: 0;
      top: 0;
      left: 0;
      z-index: 0;
    }

    td {
      padding: 24px 32px;
      position: relative;
      z-index: 2;
    }

    thead {
      tr {
        background-color: #fafcfe;
        border-bottom: 1px solid #f0f3fa;

        td {
          color: $textLight;
          font-weight: 500;
          font-size: pxToRem(10);
          line-height: pxToRem(12);

          &:first-child {
            border-radius: 16px 0 0 0;
          }

          &:last-child {
            border-radius: 0 16px 0 0;
          }
        }
      }
    }

    tbody {
      tr {
        border-bottom: 1px solid #f0f3fa;

        &:last-child {
          border-bottom: none;

          td {
            &:first-child {
              border-radius: 0 0 0 16px;
            }

            &:last-child {
              border-radius: 0 0 16px 0;
            }
          }
        }
      }
    }
  }

  &__pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 25px 0 20px;

    &-controls {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      justify-content: center;
    }

    &-button {
      min-width: 40px;
      height: 40px;
      padding: 0 12px;
      border: 1px solid #d7e1f4;
      background: white;
      color: $text;
      border-radius: 10px;
      cursor: pointer;
      font-size: pxToRem(14);
      line-height: pxToRem(19);
      transition: background-color 0.2s linear, opacity 0.2s linear;

      &--active {
        background: $action;
        color: white;
        border-color: $action;
      }

      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }

      &:hover:not(:disabled) {
        background: #f7fbff;
      }
    }
  }

  &__item {
    &-created {
      &-date {
        color: $text;
        font-size: pxToRem(12);
        line-height: pxToRem(15);
        margin-bottom: 1px;
      }

      &-time {
        color: $text;
        font-size: pxToRem(12);
        line-height: pxToRem(15);
        opacity: 0.6;
      }
    }

    &-recipient {
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: $text;
    }

    &-payment_type {
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: $text;
    }

    &-amount {
      font-size: pxToRem(12);
      line-height: pxToRem(18);
      color: $text;
      display: flex;
      align-items: center;
    }

    &-receipt {
      z-index: 9;
      position: relative;
      &-print {
        z-index: 1;
        position: relative;
        cursor: pointer;
        margin-left: 25px;
        width: 19px;
        height: 19px;

        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.2s linear;

        &:hover {
          opacity: 0.8;
        }

        svg {
          width: 100%;
          height: 100%;
        }

        &-options {
          position: absolute;
          background: #ffffff;
          border: 1px solid #f0f3fa;
          box-shadow: 0px 4px 10px rgba(232, 239, 253, 0.5);
          border-radius: 7px;
          padding: 10px 15px;
          z-index: 9;
          bottom: calc(100% + 10px);
          transform: translateX(-50%);
          left: 50%;
        }

        &-option {
          margin-bottom: 10px;
          transition: opacity 0.2s linear;
          cursor: pointer;
          white-space: nowrap;

          &:hover {
            opacity: 0.8;
          }
        }
      }
    }

    &-pay {
      &-link {
        cursor: pointer;
        margin-left: 25px;
        width: 19px;
        height: 19px;

        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.2s linear;

        &:hover {
          opacity: 0.8;
        }

        svg {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    &-actions {
      display: flex;
      align-items: center;
    }

    &-action {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 15px;
      cursor: pointer;
      transition: opacity 0.2s linear;

      &--repeat & {
        &-text {
          color: $action;
        }
      }

      &-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 10px;
      }

      &-text {
        font-weight: bold;
        font-size: pxToRem(12);
        line-height: pxToRem(18);
        color: $text;
      }

      &:hover {
        opacity: 0.8;
      }

      &:last-child {
        margin-right: 0;
      }
    }
  }

  &__total {
    display: flex;
    align-items: center;
    padding: 32px;
    border: 1px solid #f0f3fa;
    border-top: unset;
    border-radius: 0 0 16px 16px;

    &-title {
      margin-right: 84px;
      font-size: pxToRem(10);
      line-height: pxToRem(12);
      color: $textLight;
    }

    &-amount {
      display: flex;
      align-items: center;

      &-title {
        margin-right: 20px;
        font-size: pxToRem(12);
        line-height: pxToRem(18);
        color: $text;
      }

      &-value {
        font-weight: 600;
        font-size: pxToRem(16);
        line-height: pxToRem(20);
        color: $green;
      }
    }
  }

  &__receipt {
    z-index: 9;
    position: relative;
    margin-left: auto;
    margin-right: auto;

    &-print {
      z-index: 1;
      position: relative;
      cursor: pointer;
      //margin-left: 25px;
      //width: 19px;
      //height: 19px;

      display: flex;
      align-items: center;
      justify-content: center;
      transition: opacity 0.2s linear;

      &-text {
        color: $action;
        font-size: pxToRem(16);
        line-height: pxToRem(20);
        font-weight: bold;
      }

      &:hover {
        opacity: 0.8;
      }

      svg {
        width: 100%;
        height: 100%;
      }

      &-options {
        position: absolute;
        background: #ffffff;
        border: 1px solid #f0f3fa;
        box-shadow: 0px 4px 10px rgba(232, 239, 253, 0.5);
        border-radius: 7px;
        padding: 10px 15px;
        z-index: 9;
        bottom: calc(100% + 10px);
        transform: translateX(-50%);
        left: 50%;
      }

      &-option {
        margin-bottom: 10px;
        transition: opacity 0.2s linear;
        cursor: pointer;
        white-space: nowrap;

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  &-payments {
    position: relative;

    &__groups {
      position: relative;

      &:empty {
        border-top: 1px solid #f0f3fa;
      }
    }

    &__actions {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &__pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 25px 0 20px;

    &-controls {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
      justify-content: center;
    }

    &-button {
      min-width: 40px;
      height: 40px;
      padding: 0 12px;
      border: 1px solid #d7e1f4;
      background: white;
      color: $text;
      border-radius: 10px;
      cursor: pointer;
      font-size: pxToRem(14);
      line-height: pxToRem(19);
      transition: background-color 0.2s linear, opacity 0.2s linear;

      &--active {
        background: $action;
        color: white;
        border-color: $action;
      }

      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }

      &:hover:not(:disabled) {
        background: #f7fbff;
      }
    }
  }
    
  }
}
  .archive-payments {
    position: relative;
  }

  .archive-payments__loader {
    z-index: 99;
  }
</style>
